import { App, Component, defineAsyncComponent } from "vue";
import useBrowser from "../store/browser";
import MButton from "../components/medicus/MButton";
import MBanner from "../components/medicus/MBanner";
import MDynamic from "../components/medicus/MDynamic";
import MDynamicSelect from "../components/medicus/MDynamicSelect";
import MForm from "../components/medicus/MForm";
import MIcon from "../components/medicus/MIcon";
import MItem from "../components/medicus/MItem";
import MItemLabel from "../components/medicus/MItemLabel";
import MStatChip from "../components/medicus/MStatChip/MStatChip.vue"; // ENG-20962
import MStatChipBar from "../components/medicus/MStatChipBar/MStatChipBar.vue"; // ENG-20962
import MItemSection from "../components/medicus/MItemSection";
import MBadge from "../components/medicus/MBadge";
import MedicusLogo from "../svg/MedicusLogo.vue";
import MCardSection from "../components/medicus/MCardSection";
import MRadioGroup from "../components/medicus/MRadioGroup";
import MSidebar from "../components/medicus/MSidebar";
import MSpinner from "../components/medicus/MSpinner";
import MSpinnerBall from "../components/medicus/MSpinnerBall"; // ENG-20847 ← q-spinner-ball
import MInput from "../components/medicus/inputs/MInput";
import MSelect from "../components/medicus/inputs/MSelect";
import MTooltip from "../components/medicus/MTooltip";
import MTooltipBasic from "../components/medicus/MTooltipBasic";
import MToolbarTitle from "../components/medicus/MToolbarTitle";
import MTelephoneNumber from "../components/medicus/MTelephoneNumber";
import MToggle from "../components/medicus/inputs/MToggle";
import MXmlJsonViewer from "../components/medicus/MXmlJsonViewer/MXmlJsonViewer.vue"; // ENG-21348

export function componentPlugin() {
  return {
    async install(app: App) {
      // Skip component registration on unsupported browsers
      const browserStore = useBrowser();
      if (!browserStore?.supported?.supported) return;

      // load medicus components
      const modules: Record<string, () => Promise<any>> = import.meta.glob(
        "./../components/medicus/**/M*.vue",
      );

      // special components
      const loadComponents: Record<string, false | Component> = {
        MBanner,

        MButton,
        MBadge,

        MInput,
        MForm,

        MItem, // ENG-20662 ← q-item
        MRadioGroup,

        // error causing by changing props
        MSidebar,

        // trying to fix subtree error
        MDynamicSelect,
        MDynamic,

        MSelect,

        MTelephoneNumber,

        // --- Quasar→M replacements (parent initiative: ENG-20639) ---
        MIcon, // ENG-20641 ← q-icon
        MItemLabel, // ENG-20659 ← q-item-label
        MItemSection, // ENG-20658 ← q-item-section
        MSpinner, // ENG-20672 ← q-spinner
        MSpinnerBall, // ENG-20847 ← q-spinner-ball
        MTooltip, // ENG-20670 ← q-tooltip (programmatic, scroll-target)
        MTooltipBasic, // ENG-20670 ← q-tooltip (parent-anchored)
        MCardSection, // ENG-20666 ← q-card-section
        MToolbarTitle, // ENG-20845 ← q-toolbar-title
        MToggle, // ENG-20854 ← q-toggle
        MStatChip, // ENG-20962
        MStatChipBar, // ENG-20962
        MXmlJsonViewer, // ENG-21348
      };

      Object.keys(modules).map((p) => {
        const name = p.split("/").at(-1)!.slice(0, -4);
        const comp = modules[p];
        if (name in loadComponents) {
          const comp = loadComponents[name];
          if (comp === false) return;
          app.component(name, comp);
          return;
        }
        app.component(name, defineAsyncComponent(comp));
      });

      // Not under components/medicus, so the glob above misses it. Registered
      // explicitly for runtime-evaluated backend pages, which cannot import.
      app.component("MedicusLogo", MedicusLogo);
    },
  };
}
